import { createContext, useContext } from 'react';
export const ComponentConfigContext = createContext({});
export const useComponentConfig = () => useContext(ComponentConfigContext);
export const useBasketOverviewConfig = () => useComponentConfig();
